import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '2',
    display: 'grid',
    placeItems: 'center'
  },

  holder: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },

  icon: {
    marginBottom: '24px'
  },

  label: {
    fontSize: theme.size.lg,
    textAlign: 'center',
    color: '#1F1F1F'
  }
}))

export default useStyles
